module.exports = __webpack_public_path__ + "static/img/BU02PB-2.dca1378.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU02PB-2.jpg
// module id = Px8F
// module chunks = 1